/* global console */
import { copyStyle } from "../state/cellStylesSlice";
import { copyMerge } from "../state/structureSlice";

export const inheritLeftColumnStyle = (dispatch, columnIndex, cells, newCellIds, fallbackStyle, delta = 1) => {
  if (columnIndex < 1 || !cells?.length || !newCellIds) {
    console.warn(
      "To inherit column style, index must be 1 or higher and cells must exist! Additionally cell IDs must be controlled.",
      {
        columnIndex,
        cells,
        newCellIds,
      }
    );
    return;
  } else console.log("Inheriting column style", { columnIndex, newCellIds, cells, delta });

  for (let i = 0; i < newCellIds.length; i++) /* NOSONAR - makes it less readable */ {
    dispatch(
      copyStyle({
        sourceId: i < cells.length ? cells[i][columnIndex - delta].id : null,
        targetId: newCellIds[i],
        fallbackStyle,
      })
    );
    dispatch(copyMerge({ sourceColumnIndex: columnIndex - delta, targetColumnIndex: columnIndex }));
  }
};

export const inheritAboveRowStyle = (dispatch, rowIndex, cells, newCellIds, delta = 1) => {
  if (rowIndex < 1 || !cells?.length) {
    console.warn("To inherit row style, index must be 1 or higher and cells must exist!", { rowIndex, cells });
    return;
  } else console.log("Inheriting row style", { rowIndex, newCellIds, cells, delta });

  for (let i = 0; i < cells[rowIndex - delta].length; i++) {
    dispatch(copyStyle({ sourceId: cells[rowIndex - delta][i].id, targetId: newCellIds[i] }));
    dispatch(copyMerge({ sourceRowIndex: rowIndex - delta, targetRowIndex: rowIndex }));
  }
};

export const inheritStyle = (dispatch, newCellIds, style) => {
  for (let i = 0; i < newCellIds.length; i++) {
    dispatch(copyStyle({ fallbackStyle: style, targetId: newCellIds[i] }));
  }
};
